import React, {useState, useEffect, useRef} from "react";
import searchIcon from '../../../../assets/search-glass.png';
import Select from 'react-select';
import buttonRightArrow from '../../../../assets/buttons/button-arrow.svg';
import aws_region from '../../../../utils/collections/aws_region.json';
import aws_segment from '../../../../utils/collections/aws_segment.json';
import ms_region from '../../../../utils/collections/ms_region.json';
import ms_segment from '../../../../utils/collections/ms_segment_group.json';
import Button from "../../../../components/Button";
import {isNullOrEmpty} from "../../../../utils/general.js";
import Toaster from "../../../../components/Toaster";
import Icon from 'react-web-vector-icons';

import './RefineSearchComponents.scss';

const RefineSearchComponents = props => {
	const {vendor, onAction, onCancel} = props;
	const [search, setSearch] = useState('');
	const [isPasting, setIsPasting] = useState(false);
	const [regions, setRegions] = useState([]);
	const [segments, setSegments] = useState([]);
	const [regionItems, setRegionItems] = useState(aws_region.map(r => ({value: r.id, label: r.name})));
	const [segmentItems, setSegmentItems] = useState(aws_segment.map(s => ({value: s.id, label: s.name})));

	useEffect(() => {
		if(vendor === 'aws') {
			setRegionItems(aws_region.map(r => ({value: r.id, label: r.name})));
			setSegmentItems(aws_segment.map(s => ({value: s.id, label: s.name})));
		}
		else {
			setRegionItems(ms_region.map(r => ({value: r.id, label: r.name})));
			setSegmentItems(ms_segment.map(s => ({value: s.id, label: s.name})));
		}
	}, [vendor]);

	const handlePaste = (e) => {
		setIsPasting(true);
	};

	const handleInput = (e) => {
		const text = e.target.innerText;

		if (isPasting) {
			setIsPasting(false);
			e.target.innerHTML = text.replaceAll("\n", "<br/>");
		}

		setSearch(text);

		if (text !== '') {
			e.target.removeAttribute('data-placeholder');
		}
		else {
			e.target.setAttribute('data-placeholder', 'Search accounts...');
		}
	};

	const onRunManual = () => {
		if(isNullOrEmpty(search)) {
			Toaster.showWarn("Enter at least one account name.");
		}
		else {
			const accounts = search.split("\n").filter(n => n.length > 0);
			onAction({type: 'manual', accounts, regions: regions.map(r => r.value), segments: segments.map(s => s.value)});
		}
	};

	const selectStyles = {
		control: (provided, state) => ({
			...provided,
			width: '330px',
			borderRadius: '30px',
			border: '1px solid #6A8991',
			outline: 'none',
			padding: '0 5px'
		})
	};

	return (
		<div className="refine-search-container">
			<img src={searchIcon} alt="" />
			<div
				contentEditable
				className="refine-search-input"
				onInput={handleInput}
				onPaste={handlePaste}
				suppressContentEditableWarning={true}
				data-placeholder="Search accounts..." />

			<Select styles={selectStyles} isMulti={true} width={200} options={regionItems} onChange={setRegions} value={regions} placeholder="Across All Regions" />
			{/*<Dropdown width={182} items={regionItems} topOption={{key: '', label: 'Across All Regions'}} onChange={updateRegion} selectedValue={region} keyField="key" labelField="label" />*/}

			<Select styles={selectStyles} isMulti={true} width={200} options={segmentItems} onChange={setSegments} value={segments} placeholder="Across All Segments" />
			{/*<Dropdown width={182} items={segmentItems} topOption={{key: '', label: 'Across All Segments'}} onChange={updateSegment} selectedValue={segment} keyField="key" labelField="label" />*/}

			<Button type="blue" width={50} rightIcon={buttonRightArrow} onClick={onRunManual}>Go</Button>

			<span onClick={onCancel} style={{marginLeft: '20px', color: '#40A0C1', cursor: 'pointer'}}>
				<Icon name="close" font="MaterialCommunityIcons" color="#40A0C1" size={16} />
			</span>
		</div>
	)
};

export default RefineSearchComponents;